import { DateFormatter } from '@repo/toolkit/date'

import { EmailValidityStatusEnum } from '../../types/enums/information-requests/email-validity-status.enum'
import { OrigineEnum } from '../../types/enums/information-requests/origin.enum'
import { PdfTypeEnum } from '../../types/enums/information-requests/pdf-type.enum'
import { ReceiveBrochureEnum } from '../../types/enums/information-requests/recieve-brochure.enum'
import { InformationRequestFilters } from '../../types/models/information-request/information-request'

export const transformInformationRequestFiltersToUrl = (
  filters?: InformationRequestFilters
): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.createdAt) {
    if (filters.createdAt.startDate)
      searchParams.append('created_at_start', filters.createdAt.startDate)
    if (filters.createdAt.endDate) searchParams.append('created_at_end', filters.createdAt.endDate)
  }
  if (filters.printedAt) {
    if (filters.printedAt.startDate)
      searchParams.append('printed_at_start', filters.printedAt.startDate)
    if (filters.printedAt.endDate) searchParams.append('printed_at_end', filters.printedAt.endDate)
  }
  if (filters.howDidYouHearAboutUsIds && filters.howDidYouHearAboutUsIds.length)
    searchParams.append('how_did_you_hear_about_us', filters.howDidYouHearAboutUsIds.join(','))
  if (filters.inFrance !== undefined) searchParams.append('in_france', filters.inFrance.toString())
  if (filters.isPrinted !== undefined)
    searchParams.append('is_printed', filters.isPrinted.toString())
  if (filters.origins && filters.origins.length)
    searchParams.append('origins', filters.origins.join(','))
  if (filters.pdfTypes && filters.pdfTypes.length)
    searchParams.append('pdf_types', filters.pdfTypes.join(','))
  if (filters.receiveBrochureBy)
    searchParams.append('receive_brochure_by', filters.receiveBrochureBy.join(','))
  if (filters.emailValidityStatus)
    searchParams.append('email_validity_status', filters.emailValidityStatus)

  return searchParams.toString()
}

export const transformUrlToInformationRequestFilters = (
  searchParams: URLSearchParams
): InformationRequestFilters => {
  const filters: InformationRequestFilters = {}

  const createdAtStart = DateFormatter.checkDateFormat(searchParams.get('created_at_start'))
  const createdAtEnd = DateFormatter.checkDateFormat(searchParams.get('created_at_end'))
  if (createdAtStart && createdAtEnd)
    filters.createdAt = { startDate: createdAtStart, endDate: createdAtEnd }

  const printedAtStart = DateFormatter.checkDateFormat(searchParams.get('printed_at_start'))
  const printedAtEnd = DateFormatter.checkDateFormat(searchParams.get('printed_at_end'))

  if (printedAtStart && printedAtEnd)
    filters.printedAt = { startDate: printedAtStart, endDate: printedAtEnd }

  const howDidYouHearAboutUs = searchParams.get('how_did_you_hear_about_us')
  if (howDidYouHearAboutUs && howDidYouHearAboutUs.length)
    filters.howDidYouHearAboutUsIds = howDidYouHearAboutUs.split(',').map(Number)

  const inFrance = searchParams.get('in_france')
  if (inFrance) filters.inFrance = inFrance === 'true'

  const isPrinted = searchParams.get('is_printed')
  if (isPrinted) filters.isPrinted = isPrinted === 'true'

  const origins = searchParams.get('origins')
  if (origins && origins.length) filters.origins = origins.split(',') as OrigineEnum[]

  const pdfTypes = searchParams.get('pdf_types')
  if (pdfTypes && pdfTypes.length) filters.pdfTypes = pdfTypes.split(',') as PdfTypeEnum[]

  const receiveBrochureBy = searchParams.get('receive_brochure_by')
  if (receiveBrochureBy && receiveBrochureBy.length)
    filters.receiveBrochureBy = receiveBrochureBy.split(',') as ReceiveBrochureEnum[]

  const emailValidityStatus = searchParams.get('email_validity_status')
  if (emailValidityStatus)
    filters.emailValidityStatus = emailValidityStatus as EmailValidityStatusEnum

  return filters
}
